import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import AsyncPipelineStageOrderModal from './AsyncPipelineStageOrderModal';
import { List } from 'foundations-components/transitional/components/List';
import { getSelectedStageLabels } from './pipelineStageOrderEditorUtils';
import { getCurrentStages } from './journeyStageUtils';
import { EditIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryTooltip = ({
  selectedStages,
  stageLabels
}) => /*#__PURE__*/_jsx(List, {
  styled: true,
  paddingInlineStart: "200",
  marginBlockEnd: "0",
  wrapChildren: true,
  children: stageLabels.map((label, i) => /*#__PURE__*/_jsx("span", {
    children: label
  }, `stage-${selectedStages[i].stageId}`))
});
const StageEditorValue = props => {
  const {
    allPipelines,
    onChange,
    pipelinesByObject,
    report
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const selectedStages = getCurrentStages(report.toJS());
  const stageLabels = allPipelines.length > 0 ? getSelectedStageLabels(allPipelines, selectedStages) : [];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [modalOpen && /*#__PURE__*/_jsx(AsyncPipelineStageOrderModal, {
      closeModal: () => {
        setModalOpen(false);
      },
      onSubmit: onChange,
      pipelinesByObject: pipelinesByObject,
      report: report,
      selectedStages: selectedStages
    }), /*#__PURE__*/_jsx(TruncateString, {
      useFlex: true,
      fixedChildren: /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "edit-stage-order-action",
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingLabels.pipelineStageOrder.title"
        }),
        use: "link",
        onClick: () => {
          setModalOpen(true);
        },
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(EditIcon, {})
      }),
      tooltip: /*#__PURE__*/_jsx(SummaryTooltip, {
        selectedStages: selectedStages,
        stageLabels: stageLabels
      }),
      children: I18n.formatList(stageLabels)
    })]
  });
};
export default StageEditorValue;